{
  "characters": [
    {
      "id": 0,
      "name": "Luke Skywalker",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "blond",
      "height": 172,
      "eyeColor": "blue",
      "mass": 77,
      "birthYear": "19BBY"
    },
    {
      "id": 1,
      "name": "C-3PO",
      "gender": "n/a",
      "skinColor": "gold",
      "hairColor": "n/a",
      "height": 167,
      "eyeColor": "yellow",
      "mass": 75,
      "birthYear": "112BBY"
    },
    {
      "id": 2,
      "name": "R2-D2",
      "gender": "n/a",
      "skinColor": "white, blue",
      "hairColor": "n/a",
      "height": 96,
      "eyeColor": "red",
      "mass": 32,
      "birthYear": "33BBY"
    },
    {
      "id": 3,
      "name": "Darth Vader",
      "gender": "male",
      "skinColor": "white",
      "hairColor": "none",
      "height": 202,
      "eyeColor": "yellow",
      "mass": 136,
      "birthYear": "41.9BBY"
    },
    {
      "id": 4,
      "name": "Leia Organa",
      "gender": "female",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 150,
      "eyeColor": "brown",
      "mass": 49,
      "birthYear": "19BBY"
    },
    {
      "id": 5,
      "name": "Owen Lars",
      "gender": "male",
      "skinColor": "light",
      "hairColor": "brown, grey",
      "height": 178,
      "eyeColor": "blue",
      "mass": 120,
      "birthYear": "52BBY"
    },
    {
      "id": 6,
      "name": "Beru Whitesun lars",
      "gender": "female",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 165,
      "eyeColor": "blue",
      "mass": 75,
      "birthYear": "47BBY"
    },
    {
      "id": 7,
      "name": "R5-D4",
      "gender": "n/a",
      "skinColor": "white, red",
      "hairColor": "n/a",
      "height": 97,
      "eyeColor": "red",
      "mass": 32,
      "birthYear": null
    },
    {
      "id": 8,
      "name": "Biggs Darklighter",
      "gender": "male",
      "skinColor": "light",
      "hairColor": "black",
      "height": 183,
      "eyeColor": "brown",
      "mass": 84,
      "birthYear": "24BBY"
    },
    {
      "id": 9,
      "name": "Obi-Wan Kenobi",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "auburn, white",
      "height": 182,
      "eyeColor": "blue-gray",
      "mass": 77,
      "birthYear": "57BBY"
    },
    {
      "id": 10,
      "name": "Anakin Skywalker",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "blond",
      "height": 188,
      "eyeColor": "blue",
      "mass": 84,
      "birthYear": "41.9BBY"
    },
    {
      "id": 11,
      "name": "Wilhuff Tarkin",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "auburn, grey",
      "height": 180,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": "64BBY"
    },
    {
      "id": 12,
      "name": "Chewbacca",
      "gender": "male",
      "skinColor": null,
      "hairColor": "brown",
      "height": 228,
      "eyeColor": "blue",
      "mass": 112,
      "birthYear": "200BBY"
    },
    {
      "id": 13,
      "name": "Han Solo",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 180,
      "eyeColor": "brown",
      "mass": 80,
      "birthYear": "29BBY"
    },
    {
      "id": 14,
      "name": "Greedo",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "n/a",
      "height": 173,
      "eyeColor": "black",
      "mass": 74,
      "birthYear": "44BBY"
    },
    {
      "id": 15,
      "name": "Jabba Desilijic Tiure",
      "gender": "hermaphrodite",
      "skinColor": "green-tan, brown",
      "hairColor": "n/a",
      "height": 175,
      "eyeColor": "orange",
      "mass": "1,358",
      "birthYear": "600BBY"
    },
    {
      "id": 16,
      "name": "Wedge Antilles",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 170,
      "eyeColor": "hazel",
      "mass": 77,
      "birthYear": "21BBY"
    },
    {
      "id": 17,
      "name": "Jek Tono Porkins",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 180,
      "eyeColor": "blue",
      "mass": 110,
      "birthYear": null
    },
    {
      "id": 18,
      "name": "Yoda",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "white",
      "height": 66,
      "eyeColor": "brown",
      "mass": 17,
      "birthYear": "896BBY"
    },
    {
      "id": 19,
      "name": "Palpatine",
      "gender": "male",
      "skinColor": "pale",
      "hairColor": "grey",
      "height": 170,
      "eyeColor": "yellow",
      "mass": 75,
      "birthYear": "82BBY"
    },
    {
      "id": 20,
      "name": "Boba Fett",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "black",
      "height": 183,
      "eyeColor": "brown",
      "mass": 78.2,
      "birthYear": "31.5BBY"
    },
    {
      "id": 21,
      "name": "IG-88",
      "gender": "none",
      "skinColor": "metal",
      "hairColor": "none",
      "height": 200,
      "eyeColor": "red",
      "mass": 140,
      "birthYear": "15BBY"
    },
    {
      "id": 22,
      "name": "Bossk",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "none",
      "height": 190,
      "eyeColor": "red",
      "mass": 113,
      "birthYear": "53BBY"
    },
    {
      "id": 23,
      "name": "Lando Calrissian",
      "gender": "male",
      "skinColor": "dark",
      "hairColor": "black",
      "height": 177,
      "eyeColor": "brown",
      "mass": 79,
      "birthYear": "31BBY"
    },
    {
      "id": 24,
      "name": "Lobot",
      "gender": "male",
      "skinColor": "light",
      "hairColor": "none",
      "height": 175,
      "eyeColor": "blue",
      "mass": 79,
      "birthYear": "37BBY"
    },
    {
      "id": 25,
      "name": "Ackbar",
      "gender": "male",
      "skinColor": "brown mottle",
      "hairColor": "none",
      "height": 180,
      "eyeColor": "orange",
      "mass": 83,
      "birthYear": "41BBY"
    },
    {
      "id": 26,
      "name": "Mon Mothma",
      "gender": "female",
      "skinColor": "fair",
      "hairColor": "auburn",
      "height": 150,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": "48BBY"
    },
    {
      "id": 27,
      "name": "Arvel Crynyd",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": null,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 28,
      "name": "Wicket Systri Warrick",
      "gender": "male",
      "skinColor": "brown",
      "hairColor": "brown",
      "height": 88,
      "eyeColor": "brown",
      "mass": 20,
      "birthYear": "8BBY"
    },
    {
      "id": 29,
      "name": "Nien Nunb",
      "gender": "male",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 160,
      "eyeColor": "black",
      "mass": 68,
      "birthYear": null
    },
    {
      "id": 30,
      "name": "Qui-Gon Jinn",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 193,
      "eyeColor": "blue",
      "mass": 89,
      "birthYear": "92BBY"
    },
    {
      "id": 31,
      "name": "Nute Gunray",
      "gender": "male",
      "skinColor": "mottled green",
      "hairColor": "none",
      "height": 191,
      "eyeColor": "red",
      "mass": 90,
      "birthYear": null
    },
    {
      "id": 32,
      "name": "Finis Valorum",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "blond",
      "height": 170,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": "91BBY"
    },
    {
      "id": 33,
      "name": "Padmé Amidala",
      "gender": "female",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 185,
      "eyeColor": "brown",
      "mass": 45,
      "birthYear": "46BBY"
    },
    {
      "id": 34,
      "name": "Jar Jar Binks",
      "gender": "male",
      "skinColor": "orange",
      "hairColor": "none",
      "height": 196,
      "eyeColor": "orange",
      "mass": 66,
      "birthYear": "52BBY"
    },
    {
      "id": 35,
      "name": "Roos Tarpals",
      "gender": "male",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 224,
      "eyeColor": "orange",
      "mass": 82,
      "birthYear": null
    },
    {
      "id": 36,
      "name": "Rugor Nass",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "none",
      "height": 206,
      "eyeColor": "orange",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 37,
      "name": "Ric Olié",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 183,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 38,
      "name": "Watto",
      "gender": "male",
      "skinColor": "blue, grey",
      "hairColor": "black",
      "height": 137,
      "eyeColor": "yellow",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 39,
      "name": "Sebulba",
      "gender": "male",
      "skinColor": "grey, red",
      "hairColor": "none",
      "height": 112,
      "eyeColor": "orange",
      "mass": 40,
      "birthYear": null
    },
    {
      "id": 40,
      "name": "Quarsh Panaka",
      "gender": "male",
      "skinColor": "dark",
      "hairColor": "black",
      "height": 183,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": "62BBY"
    },
    {
      "id": 41,
      "name": "Shmi Skywalker",
      "gender": "female",
      "skinColor": "fair",
      "hairColor": "black",
      "height": 163,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": "72BBY"
    },
    {
      "id": 42,
      "name": "Darth Maul",
      "gender": "male",
      "skinColor": "red",
      "hairColor": "none",
      "height": 175,
      "eyeColor": "yellow",
      "mass": 80,
      "birthYear": "54BBY"
    },
    {
      "id": 43,
      "name": "Bib Fortuna",
      "gender": "male",
      "skinColor": "pale",
      "hairColor": "none",
      "height": 180,
      "eyeColor": "pink",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 44,
      "name": "Ayla Secura",
      "gender": "female",
      "skinColor": "blue",
      "hairColor": "none",
      "height": 178,
      "eyeColor": "hazel",
      "mass": 55,
      "birthYear": "48BBY"
    },
    {
      "id": 45,
      "name": "Ratts Tyerel",
      "gender": "male",
      "skinColor": "grey, blue",
      "hairColor": "none",
      "height": 79,
      "eyeColor": null,
      "mass": 15,
      "birthYear": null
    },
    {
      "id": 46,
      "name": "Dud Bolt",
      "gender": "male",
      "skinColor": "blue, grey",
      "hairColor": "none",
      "height": 94,
      "eyeColor": "yellow",
      "mass": 45,
      "birthYear": null
    },
    {
      "id": 47,
      "name": "Gasgano",
      "gender": "male",
      "skinColor": "white, blue",
      "hairColor": "none",
      "height": 122,
      "eyeColor": "black",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 48,
      "name": "Ben Quadinaros",
      "gender": "male",
      "skinColor": "grey, green, yellow",
      "hairColor": "none",
      "height": 163,
      "eyeColor": "orange",
      "mass": 65,
      "birthYear": null
    },
    {
      "id": 49,
      "name": "Mace Windu",
      "gender": "male",
      "skinColor": "dark",
      "hairColor": "none",
      "height": 188,
      "eyeColor": "brown",
      "mass": 84,
      "birthYear": "72BBY"
    },
    {
      "id": 50,
      "name": "Ki-Adi-Mundi",
      "gender": "male",
      "skinColor": "pale",
      "hairColor": "white",
      "height": 198,
      "eyeColor": "yellow",
      "mass": 82,
      "birthYear": "92BBY"
    },
    {
      "id": 51,
      "name": "Kit Fisto",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "none",
      "height": 196,
      "eyeColor": "black",
      "mass": 87,
      "birthYear": null
    },
    {
      "id": 52,
      "name": "Eeth Koth",
      "gender": "male",
      "skinColor": "brown",
      "hairColor": "black",
      "height": 171,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 53,
      "name": "Adi Gallia",
      "gender": "female",
      "skinColor": "dark",
      "hairColor": "none",
      "height": 184,
      "eyeColor": "blue",
      "mass": 50,
      "birthYear": null
    },
    {
      "id": 54,
      "name": "Saesee Tiin",
      "gender": "male",
      "skinColor": "pale",
      "hairColor": "none",
      "height": 188,
      "eyeColor": "orange",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 55,
      "name": "Yarael Poof",
      "gender": "male",
      "skinColor": "white",
      "hairColor": "none",
      "height": 264,
      "eyeColor": "yellow",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 56,
      "name": "Plo Koon",
      "gender": "male",
      "skinColor": "orange",
      "hairColor": "none",
      "height": 188,
      "eyeColor": "black",
      "mass": 80,
      "birthYear": "22BBY"
    },
    {
      "id": 57,
      "name": "Mas Amedda",
      "gender": "male",
      "skinColor": "blue",
      "hairColor": "none",
      "height": 196,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 58,
      "name": "Gregar Typho",
      "gender": "male",
      "skinColor": "dark",
      "hairColor": "black",
      "height": 185,
      "eyeColor": "brown",
      "mass": 85,
      "birthYear": null
    },
    {
      "id": 59,
      "name": "Cordé",
      "gender": "female",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 157,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 60,
      "name": "Cliegg Lars",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "brown",
      "height": 183,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": "82BBY"
    },
    {
      "id": 61,
      "name": "Poggle the Lesser",
      "gender": "male",
      "skinColor": "green",
      "hairColor": "none",
      "height": 183,
      "eyeColor": "yellow",
      "mass": 80,
      "birthYear": null
    },
    {
      "id": 62,
      "name": "Luminara Unduli",
      "gender": "female",
      "skinColor": "yellow",
      "hairColor": "black",
      "height": 170,
      "eyeColor": "blue",
      "mass": 56.2,
      "birthYear": "58BBY"
    },
    {
      "id": 63,
      "name": "Barriss Offee",
      "gender": "female",
      "skinColor": "yellow",
      "hairColor": "black",
      "height": 166,
      "eyeColor": "blue",
      "mass": 50,
      "birthYear": "40BBY"
    },
    {
      "id": 64,
      "name": "Dormé",
      "gender": "female",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 165,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 65,
      "name": "Dooku",
      "gender": "male",
      "skinColor": "fair",
      "hairColor": "white",
      "height": 193,
      "eyeColor": "brown",
      "mass": 80,
      "birthYear": "102BBY"
    },
    {
      "id": 66,
      "name": "Bail Prestor Organa",
      "gender": "male",
      "skinColor": "tan",
      "hairColor": "black",
      "height": 191,
      "eyeColor": "brown",
      "mass": null,
      "birthYear": "67BBY"
    },
    {
      "id": 67,
      "name": "Jango Fett",
      "gender": "male",
      "skinColor": "tan",
      "hairColor": "black",
      "height": 183,
      "eyeColor": "brown",
      "mass": 79,
      "birthYear": "66BBY"
    },
    {
      "id": 68,
      "name": "Zam Wesell",
      "gender": "female",
      "skinColor": "fair, green, yellow",
      "hairColor": "blonde",
      "height": 168,
      "eyeColor": "yellow",
      "mass": 55,
      "birthYear": null
    },
    {
      "id": 69,
      "name": "Dexter Jettster",
      "gender": "male",
      "skinColor": "brown",
      "hairColor": "none",
      "height": 198,
      "eyeColor": "yellow",
      "mass": 102,
      "birthYear": null
    },
    {
      "id": 70,
      "name": "Lama Su",
      "gender": "male",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 229,
      "eyeColor": "black",
      "mass": 88,
      "birthYear": null
    },
    {
      "id": 71,
      "name": "Taun We",
      "gender": "female",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 213,
      "eyeColor": "black",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 72,
      "name": "Jocasta Nu",
      "gender": "female",
      "skinColor": "fair",
      "hairColor": "white",
      "height": 167,
      "eyeColor": "blue",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 73,
      "name": "R4-P17",
      "gender": "female",
      "skinColor": "silver, red",
      "hairColor": "none",
      "height": 96,
      "eyeColor": "red, blue",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 74,
      "name": "Wat Tambor",
      "gender": "male",
      "skinColor": "green, grey",
      "hairColor": "none",
      "height": 193,
      "eyeColor": null,
      "mass": 48,
      "birthYear": null
    },
    {
      "id": 75,
      "name": "San Hill",
      "gender": "male",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 191,
      "eyeColor": "gold",
      "mass": null,
      "birthYear": null
    },
    {
      "id": 76,
      "name": "Shaak Ti",
      "gender": "female",
      "skinColor": "red, blue, white",
      "hairColor": "none",
      "height": 178,
      "eyeColor": "black",
      "mass": 57,
      "birthYear": null
    },
    {
      "id": 77,
      "name": "Grievous",
      "gender": "male",
      "skinColor": "brown, white",
      "hairColor": "none",
      "height": 216,
      "eyeColor": "green, yellow",
      "mass": 159,
      "birthYear": null
    },
    {
      "id": 78,
      "name": "Tarfful",
      "gender": "male",
      "skinColor": "brown",
      "hairColor": "brown",
      "height": 234,
      "eyeColor": "blue",
      "mass": 136,
      "birthYear": null
    },
    {
      "id": 79,
      "name": "Raymus Antilles",
      "gender": "male",
      "skinColor": "light",
      "hairColor": "brown",
      "height": 188,
      "eyeColor": "brown",
      "mass": 79,
      "birthYear": null
    },
    {
      "id": 80,
      "name": "Sly Moore",
      "gender": "female",
      "skinColor": "pale",
      "hairColor": "none",
      "height": 178,
      "eyeColor": "white",
      "mass": 48,
      "birthYear": null
    },
    {
      "id": 81,
      "name": "Tion Medon",
      "gender": "male",
      "skinColor": "grey",
      "hairColor": "none",
      "height": 206,
      "eyeColor": "black",
      "mass": 80,
      "birthYear": null
    }
  ]
}
